module.exports = __webpack_public_path__ + "static/552-739a92fd4780fa2512368ebba5f40436.jpg";